import ApiCollection          from '@widesk-core/models/ApiCollection';
import StonecodeFileFileModel from '@models/file/StonecodeFileFileModel';
import uploadFileForModelUrn  from '@/helpers/uploadFileForModelUrn';

/**
 * Pose, remplace ou retire LE fichier d'un type donné pour une source.
 *
 * « Single » est la promesse de cette fonction : après son passage, la source porte au plus un
 * fichier de cette référence. Elle ne la tenait pas — un envoi ajoutait le nouveau fichier sans
 * retirer l'ancien, et les sources en accumulaient. L'effet visible : on supprimait l'image d'un
 * point d'intérêt, un exemplaire précédent reprenait sa place, et la suppression paraissait sans
 * effet.
 *
 * Les existants sont donc retirés dans TOUS les cas — remplacement compris — et TOUS, pas seulement
 * le premier, pour rattraper les sources déjà encombrées.
 *
 * `file` : un fichier pour poser ou remplacer, `false` pour retirer, `undefined` pour retirer aussi
 * (un appelant qui ne fournit rien alors qu'il connaît un fichier d'origine demande son retrait).
 *
 * Retourne le fichier créé, le cas échéant : le service de fichiers met un instant à le faire
 * apparaître dans ses listes, et l'appelant a besoin de l'afficher tout de suite sans avoir à les
 * redemander.
 */
export default async function updateSingleFileForModelUrn(
	modelUrn: Urn,
	reference: File_StonecodeFileTypeReference,
	file?: File | false,
	originalFile?: StonecodeFileFileModel,
) {
	const existing = new ApiCollection(StonecodeFileFileModel);

	await existing
		.setRequiredFilter('fileStatus.reference', 'available')
		.setRequiredFilter('typeSource.type.reference', reference)
		.setRequiredFilter('typeSource.source.entityUrn', modelUrn)
		.list();

	// `originalFile` est celui que l'appelant a sous les yeux : il peut ne pas figurer dans la liste
	// si celle-ci a été servie avant son ajout. On le joint, sans doublon.
	const toRemove = [
		...existing.models,
		...(originalFile && !existing.models.some(m => m.id === originalFile.id) ? [originalFile] : []),
	];

	await Promise.all(toRemove.map(model => model.destroy()));

	if (file) return uploadFileForModelUrn(modelUrn, reference, file);

	return undefined;
}
